var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('view-selector',{attrs:{"view":_vm.view,"current-date":_vm.currentDate},on:{"update:view":_vm.setView,"update:currentDate":_vm.setCurrentDate,"startDate":_vm.setStartDate,"endDate":_vm.setEndDate}})}
var staticRenderFns = []

export { render, staticRenderFns }